import { convertPX } from '@/utils/echarts';
import cssVar from '@/style/variable.module.less';

export function createLegendOptions(formatter) {
	return {
		type: 'scroll',
		bottom: 0,
		padding: 0,
		itemGap: convertPX(16),
		// itemWidth: convertPX(14),
		// itemHeight: convertPX(14),
		itemWidth: convertPX(10),
		itemHeight: convertPX(10),
		formatter,
		inactiveColor: cssVar['--disabled-color'],
		// 加大高度，防止文本被截取
		itemStyle: {
			// borderWidth: 4,
			// borderColor: '#fff'
		},
		textStyle: {
			color: cssVar['--secondary-color'],
			fontSize: convertPX(12),
			lineHeight: convertPX(18),
			height: convertPX(18),
			// 配合垂直居中
			padding: [0, 0, -2, 0],
			rich: {
				a: {
					verticalAlign: 'middle'
				}
			}
		},
		icon: 'roundRect',
		pageButtonItemGap: convertPX(6),
		pageButtonGap: convertPX(16),
		pageIconColor: cssVar['--secondary-color'],
		pageIconInactiveColor: cssVar['--disabled-color'],
		pageIconSize: convertPX(10),
		pageTextStyle: {
			color: cssVar['--secondary-color'],
			height: convertPX(18)
		},
		animation: true
	};
}
